export const EstadoVistaColaborador = {
    PENDIENTE: "PENDIENTE",
    PENDIENTE_APROBACION: "PENDIENTE_APROBACION",
    VISUALIZADO: "VISUALIZADO",
    FIRMADO: "FIRMADO",
    RECHAZADO:"RECHAZADO"
}